/**
 * Created by Chris on 13/03/17.
 */




export const validate = (values) => {

    const errors = {};
    if (!values.email) {
        errors.email = 'Required'
    }
    if (!values.name) {
        errors.name = 'Required'
    }
    if (!values.phone) {
        //errors.phone = 'Required'
    }
    return errors
};





// WEBPACK FOOTER //
// ./src/components/common/ProfileValidation.js